
import {Component, Vue} from 'vue-property-decorator';
import RulesUtil from "@/util/rules";
import ContatoModel from '@/models/cliente/contato.model';
import Listas from "@/models/lists/listas.model";
import ContatoService from "@/service/contato.service"
import {namespace} from "vuex-class";
import {MapGettersCliente} from "@/store/modules/cliente/map-getters.cliente";

const clienteStore = namespace('cliente');

@Component({
  name: "contato-component"
})
export default class ContatoComponent extends Vue {

  @clienteStore.Getter(MapGettersCliente.ID) id;

  private page = 0;
  private rules = RulesUtil;
  private openDelete = false;
  private listas = new Listas();
  private contato = new ContatoModel();
  private idContatoSelecionado: number | null = null;
  private idCliente = 0;
  private listaContatos: Array<ContatoModel> = [];

  async saveUpdateContato() {
    if ((this.$refs.formContato as HTMLFormElement).validate()) {
      const id_entidade = this.idCliente ? this.idCliente : this.id;
      this.contato.id_entidade = id_entidade;
      if (this.contato && this.contato.id) {
        await ContatoService.atualizar(this.contato);
      } else {
        await ContatoService.cadastrar(this.contato);
      }
      (this.$refs.formContato as HTMLFormElement).reset();
      this.contato = new ContatoModel();
      this.listaContatos = await ContatoService.buscarTodos(id_entidade);
      this.$emit("atualizaStep", this.listaContatos.length);
    }
  }

  nextStep(step: number) {
    this.$emit("nextStep", step);
  }

  async dadosUp(item: ContatoModel) {
    const contatoSelecionado: ContatoModel = Object.assign({}, item);
    this.contato = contatoSelecionado;
  }

  goDelete(item: ContatoModel) {
    this.idContatoSelecionado = item.id;
    this.openDelete = true;
  }

  async deletar() {
    await ContatoService.delete(this.idContatoSelecionado);
    this.openDelete = false;
    const id_entidade = this.idCliente ? this.idCliente : this.id;
    this.listaContatos = await ContatoService.buscarTodos(id_entidade);
    this.$emit("atualizaStep", this.listaContatos.length);
  }

  async mounted() {
    const idCliente: any = this.$route.params.id;
    if (idCliente) {
      this.idCliente = idCliente;
      this.listaContatos = await ContatoService.buscarTodos(this.idCliente);
    }
  }

}
